export default class {
    constructor(Component) {
        this.Component  = Component;
        /* elements selector */
        this.container  = $(Component.container); // @todo: remove jquery
        this.sort       = this.container.find('.js-overview-sort').find('select');
        this.content    = Component.container.querySelector('.overview-filter-content');
    }

    get groups() {
        return this.container.find('.js-filter');
    }

    selectSort(sort) {
        this.container.find('select[name=sort]').value = sort;
        return this;
    }

    changeSortSelectToRelevance() {
        this.sort.find('option').attr('selected', false);
        this.sort.find('option[value=relevance]').attr('selected', true);
    }

    hideAllFilterItems() {
        this.container.find('input[name=filter]').parents('li').removeClass('enable');
    }

    showFilterItem(key) {
        this.container.find('input[name=filter][value="' + key + '"]').parents('li').addClass('enable');
    }

    activateFilterItem(key) {
        this.container.find('input[name=filter][value="' + key + '"]').prop('checked', true);
    }

    showFilterGroups() {
        let self = this;
        this.groups.each(function() {
            let element = $(this);
            let parent = element.parents('.filter-nav-box');
            if (self.Component.Interface.Filter.groupHasItems(parent.data('key'))) {
                parent.removeClass('disabled');
            } else {
                parent.addClass('disabled');
            }
        });
    }

    unselectFilters() {
        this.container.find('[name=filter]').prop('checked', false);
        return this;
    }
}
